/**
 * Guided-planning host for the shared account-capture screen: guided session inputs (see
 * `useGuidedAccountCapture`), no minimum-account rule (a guided user may only have an existing
 * policy), wizard Back/Next, rendered inside `StepLayout`.
 */
import { useWizard } from 'react-use-wizard';

import { FundingSourceAccounts } from '@/features/funding-sources';
import { StepLayout } from '@/features/guided-financial-planning/components/step-layout';
import { useGuidedAccountCapture } from '@/features/guided-financial-planning/hooks/use-guided-account-capture';

export function AssessmentAccountsStep() {
  const { nextStep, previousStep } = useWizard();
  const capture = useGuidedAccountCapture();

  return (
    <FundingSourceAccounts
      {...capture}
      requireSelfFundingAccount={false}
      onContinue={nextStep}
      onBack={previousStep}
      frame={parts => (
        <StepLayout
          title={parts.title}
          subtitle={parts.subtitle}
          nextButtonLabel={parts.primaryAction?.label}
          isNextDisabled={parts.primaryAction?.disabled}
          onNext={parts.primaryAction?.onSelect}
          onBack={parts.backAction?.onSelect}
        >
          {parts.content}
        </StepLayout>
      )}
    />
  );
}
